import React from 'react'
import Table from 'components/Table'
import CurrencyItem from 'components/CurrencyItem'
import ChartTabs from 'components/ChartTabs'
import { numberFormatter } from 'utils/formatters'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

export const CurrencyList = ({title, rates, ...props}) => {
	const columns = [{
		dataField: 'id',
		text: 'ID',
		hidden: true
	}, {
		dataField: 'currency',
		text: 'Име на валута',
		headerAlign: 'left',
		formatter: (cell, row) => <CurrencyItem currency={cell} />,
		filterValue: (cell, row) => `${cell.name} ${cell.abbreviature}`
	}, {
		dataField: 'unit',
		text: 'За единици валута',
		headerAlign: 'left',
		align: 'right',
		headerStyle: () => {
			return { width: '150px' }
		}
	}, {
		dataField: 'conversion_value',
		text: 'Курс (BGN)',
		headerAlign: 'center',
		formatter: (cell, row) => numberFormatter({ value: cell, thousandSeparator: ' ' }),
		filterValue: (cell, row) => cell,
		align: 'center'
	}, {
		dataField: 'inverse_conversion_value',
		text: 'Обърнат курс',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '120px' }
		}
	}, {
		dataField: 'link',
		text: '',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '100px' }
		}
	}]

	const expandRow = {
		renderer: row => <ChartTabs currency={row.to_currency_id} {...props} />
	}

	const paginationSettings = {
		sizePerPage: 5,
	}

	return <Table
		title={title}
		data={rates.map(rate => ({
			...rate,
			conversion_value: rate.conversion_value,
			inverse_conversion_value: rate.inverse_conversion_value,
			currency: {
				name: rate.name,
				abbreviature: rate.abbreviature,
				flag: `${rate.flag}`
			},
			unit: rate.quantity,
			link: <Link to={`/currencies/rates/${rate.abbreviature}`} className='u-text--cornflower u-underline'>Виж</Link>
		}))}
		columns={columns}
		expandRow={expandRow}
		headerClasses='u-text--manatee u-weight--normal'
		paginationSettings={paginationSettings}
		search
	/>
}

CurrencyList.propTypes = {
	title: PropTypes.string,
	rates: PropTypes.arrayOf(PropTypes.shape({
		conversion_value: PropTypes.number,
		inverse_conversion_value: PropTypes.number,
		name: PropTypes.string,
		abbreviature: PropTypes.string,
		flag: PropTypes.string,
		quantity: PropTypes.number
	}))
}

export default CurrencyList
